import { changeZipOnlineScheduleFlow } from "../../util/mra-form-information";

export function changeZipCodeInContactScreenFlow(){
    $('.contact-information-screen input[name="inputZipCode"]').keyup(function (this: any){
        var value: any = $(this).val();
        changeZipOnlineScheduleFlow(value);
    });
}